import { AvatarSize } from '$common/avatar'
import { WorkspaceAvatar } from '$common/avatar/workspace-avatar/workspace-avatar'
import { BottomDrawer } from '$common/bottom-drawer'
import { useClientUserWorkspaces } from '$logic/workspace'
import { ListItemButton, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { t } from '$i18n'

export function SelectWorkspace({
  onSelect,
}: {
  onSelect: (workspaceId: string, workspaceName: string) => unknown
}) {
  const { value: workspaces, loading } = useClientUserWorkspaces()

  return (
    <BottomDrawer isOpen={true} onClose={closeCurrentModal}>
      <Typography margin="12px 16px" color="secondary700" variant="subtitle3">
        {t('selectWorkspace.title')}
      </Typography>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {workspaces?.map(workspace => (
          <StyledListItemButton
            key={workspace.id}
            onClick={() => onSelect(workspace.id, workspace.name)}
          >
            <WorkspaceAvatar workspaceId={workspace.id} size={AvatarSize.MD} />
            <Typography variant="subtitle2" color="neutral1000">
              {workspace.name}
            </Typography>
          </StyledListItemButton>
        ))}
      </div>
    </BottomDrawer>
  )
}

const StyledListItemButton = styled(ListItemButton)`
  display: flex;
  gap: 16px;
  padding: 12px 16px;
  width: 100%;
`
